var _a;
import { __extends } from "tslib";
import { GroupsSortBy, } from '@wix/ambassador-social-groups-v1-group/types';
import { PrivacyStatus, SortOrder, } from '@wix/ambassador-social-groups-v2-group/types';
import { QueryBuilder } from '../QueryBuilder/QueryBuilder';
export var GroupsRequestSort;
(function (GroupsRequestSort) {
    GroupsRequestSort["MEMBERS_COUNT"] = "members_count";
    GroupsRequestSort["RECENT_ACTIVITY"] = "recent_activity_date";
    GroupsRequestSort["NAME"] = "title";
})(GroupsRequestSort || (GroupsRequestSort = {}));
export var GroupSortFieldMapping = (_a = {},
    _a[GroupsSortBy.RECENT_ACTIVITY] = GroupsRequestSort.RECENT_ACTIVITY,
    _a[GroupsSortBy.MEMBERS_COUNT] = GroupsRequestSort.MEMBERS_COUNT,
    _a[GroupsSortBy.NAME] = GroupsRequestSort.NAME,
    _a[GroupsRequestSort.RECENT_ACTIVITY] = GroupsSortBy.RECENT_ACTIVITY,
    _a[GroupsRequestSort.MEMBERS_COUNT] = GroupsSortBy.MEMBERS_COUNT,
    _a[GroupsRequestSort.NAME] = GroupsSortBy.NAME,
    _a);
var GroupsRequestBuilder = /** @class */ (function (_super) {
    __extends(GroupsRequestBuilder, _super);
    function GroupsRequestBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupsRequestBuilder.prototype.sortByMembersCount = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.MEMBERS_COUNT, order);
    };
    GroupsRequestBuilder.prototype.excludeSecretGroups = function () {
        return this.addFilter({
            privacyLevel: {
                $ne: PrivacyStatus.SECRET,
            },
        });
    };
    GroupsRequestBuilder.prototype.withTitleContains = function ($contains) {
        return this.addFilter({
            title: {
                $contains: $contains,
            },
        });
    };
    GroupsRequestBuilder.prototype.withGroupIds = function ($in) {
        return this.addFilter({
            groupId: {
                $in: $in,
            },
        });
    };
    GroupsRequestBuilder.prototype.sortByRecentActivity = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.RECENT_ACTIVITY, order);
    };
    GroupsRequestBuilder.prototype.sortByName = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.NAME, order);
    };
    GroupsRequestBuilder.prototype.sortByCreatedDate = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort('createdDate', order);
    };
    GroupsRequestBuilder.prototype.sortByUpdatesCount = function (order) {
        if (order === void 0) { order = SortOrder.DESC; }
        return this.addSort('updatesCount', order);
    };
    GroupsRequestBuilder.prototype.sortByPendingMembersCount = function (order) {
        if (order === void 0) { order = SortOrder.DESC; }
        return this.addSort('pendingMembersCount', order);
    };
    GroupsRequestBuilder.prototype.sortByRecentActivityDateV2 = function (order) {
        if (order === void 0) { order = SortOrder.DESC; }
        return this.addSort('recentActivityDate', order);
    };
    GroupsRequestBuilder.prototype.build = function () {
        return { query: this.query };
    };
    return GroupsRequestBuilder;
}(QueryBuilder));
export { GroupsRequestBuilder };
//# sourceMappingURL=GroupsRequestBuilder.js.map